
import { HiCash } from 'react-icons/hi';
import ListCobros from './ListCobros';

export default {
  icon: HiCash,
  list: ListCobros,
};